import { useEffect, useRef, useState } from "react";

import GuestImg from "../../assets/images/conversations/ep-40-vasudha-madhavan-guest.webp";
import ThumbImg from "../../assets/images/conversations/040.webp";
import PlayIcon  from "../../assets/icons/conversations/play-icon.svg";

/* ─────────────────────────────────────────────
   PREFIX: vm-
───────────────────────────────────────────── */
const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700;800&family=Roboto:wght@400;500&display=swap');

  *, *::before, *::after { margin: 0; padding: 0; box-sizing: border-box; }

  .vm-page {
    background: #1A1A1A;
    min-height: 100vh;
    font-family: 'Roboto', sans-serif;
    color: #fff;
  }
  .vm-inner {
    max-width: 1600px;
    margin: 0 auto;
    padding-left: 102px;
    padding-right: 102px;
  }

  /* ══════════════════════════════════════
     SECTION 1 — HERO
  ══════════════════════════════════════ */
  .vm-hero { padding-top: 60px; padding-bottom: 60px; }
  .vm-hero__grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 30px;
    align-items: start;
  }
  .vm-hero__left { display: flex; flex-direction: column; gap: 44px; }
  .vm-hero__title {
    font-family: 'Montserrat', sans-serif;
    font-size: 32px;
    font-weight: 700;
    color: #ffffff;
    line-height: 140%;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .vm-hero__title.vm-visible { opacity: 1; transform: translateY(0); }
  .vm-hero__spotify {
    border-radius: 12px;
    overflow: hidden;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease 0.18s, transform 0.7s ease 0.18s;
  }
  .vm-hero__spotify.vm-visible { opacity: 1; transform: translateY(0); }
  .vm-hero__spotify iframe {
    display: block; width: 100%; height: 152px; border: none; border-radius: 12px;
  }
  .vm-hero__right {
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease 0.1s, transform 0.7s ease 0.1s;
  }
  .vm-hero__right.vm-visible { opacity: 1; transform: translateY(0); }

  /* thumbnail */
  .vm-yt-thumb {
    position: relative; width: 100%; border-radius: 12px;
    overflow: hidden; cursor: pointer; display: block; background: #000;
  }
  .vm-yt-thumb img {
    width: 100%; height: auto; display: block;
    border-radius: 12px; transition: opacity 0.3s ease;
  }
  .vm-yt-thumb:hover img { opacity: 0.85; }
  .vm-yt-thumb__play {
    position: absolute; top: 50%; left: 50%;
    transform: translate(-50%, -50%);
    background: none; border-radius: 50%;
    display: flex; align-items: center; justify-content: center;
    pointer-events: none;
  }
  .vm-yt-thumb__play img { width: 40px; height: 44px; }
  .vm-yt-iframe-wrap {
    position: relative; width: 100%; padding-bottom: 56.25%;
    height: 0; border-radius: 12px; overflow: hidden;
  }
  .vm-yt-iframe-wrap iframe {
    position: absolute; top: 0; left: 0;
    width: 100%; height: 100%; border: none;
  }

  /* ══════════════════════════════════════
     SECTION 2 — BODY
  ══════════════════════════════════════ */
  .vm-body {
    padding-bottom: 100px; opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .vm-body.vm-visible { opacity: 1; transform: translateY(0); }
  .vm-body__para {
    font-family: 'Roboto', sans-serif; font-size: 16px;
    font-weight: 400; color: #E2E2E2; line-height: 160%; margin-bottom: 14px;
  }
  .vm-body__para:last-child { margin-bottom: 0; }

  /* ══════════════════════════════════════
     SECTION 3 — OUR GUEST (1 guest)
  ══════════════════════════════════════ */
  .vm-guest {
    padding-bottom: 100px; text-align: center; opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .vm-guest.vm-visible { opacity: 1; transform: translateY(0); }
  .vm-guest__title {
    font-family: 'Montserrat', sans-serif; font-size: 50px;
    font-weight: 700; color: #ffffff; margin-bottom: 60px;
  }
  .vm-guest__photo-bg {
    display: inline-block; width: 445px; height: 500px;
    background: #743FAC; border-radius: 12px; overflow: hidden;
  }
  .vm-guest__photo-bg img {
    width: 100%; height: 100%; object-fit: cover;
    object-position: top center; display: block;
  }
  .vm-guest__name {
    font-family: 'Montserrat', sans-serif; font-size: 32px;
    font-weight: 700; color: #ffffff; margin-top: 24px;
  }

  /* ── TABLET (max 768px) ── */
  @media (max-width: 768px) {
    .vm-inner { padding-left: 32px; padding-right: 32px; }
    .vm-hero { padding-top: 32px; padding-bottom: 48px; }
    .vm-hero__grid { grid-template-columns: 1fr 1fr; gap: 24px; }
    .vm-hero__title { font-size: 24px; }
    .vm-hero__left { gap: 16px; }
    .vm-guest__title { font-size: 24px; margin-bottom: 24px; }
    .vm-guest__photo-bg { width: 260px; height: 300px; }
    .vm-guest__name { font-size: 24px; margin-top: 18px; }
    .vm-body__para { font-size: 14px; margin-bottom: 12px; }
    .vm-body { padding-bottom: 48px; }
    .vm-guest { padding-bottom: 48px; }
    .vm-yt-thumb__play img { width: 30px; height: 32px; }
  }

  /* ── MOBILE (max 480px) ── */
  @media (max-width: 480px) {
    .vm-inner { padding-left: 16px; padding-right: 16px; }
    .vm-hero { padding-top: 51px; padding-bottom: 30px; }
    .vm-hero__grid { grid-template-columns: 1fr; gap: 30px; }
    .vm-hero__left { gap: 30px; }
    .vm-hero__title { font-size: 30px; }
    .vm-body__para { font-size: 16px; margin-bottom: 10px; }
    .vm-guest__title { font-size: 30px; margin-bottom: 20px; }
    .vm-guest__photo-bg { width: 100%; height: 386px; }
    .vm-guest__name { font-size: 24px; text-align: left; margin-top: 14px; }
    .vm-body { padding-bottom: 30px; }
    .vm-guest { padding-bottom: 30px; }
    .vm-yt-thumb__play img { width: 30px; height: 32px; }
  }
`;

function useFadeUp(ref) {
  useEffect(() => {
    if (!ref.current) return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("vm-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);
}

const YT_VIDEO_ID = "PVjvjNJFXYw";

function YouTubeEmbed() {
  const [playing, setPlaying] = useState(false);
  if (playing) {
    return (
      <div className="vm-yt-iframe-wrap">
        <iframe
          src={`https://www.youtube.com/embed/${YT_VIDEO_ID}?autoplay=1&rel=0`}
          title="EP 40 Vasudha Madhavan"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>
    );
  }
  return (
    <div className="vm-yt-thumb" onClick={() => setPlaying(true)} role="button" aria-label="Play video">
      <img src={ThumbImg} alt="EP 40 Vasudha Madhavan thumbnail" />
      <div className="vm-yt-thumb__play">
        <img src={PlayIcon} alt="Play" />
      </div>
    </div>
  );
}

function HeroSection() {
  const titleRef   = useRef(null);
  const spotifyRef = useRef(null);
  const rightRef   = useRef(null);
  useFadeUp(titleRef);
  useFadeUp(spotifyRef);
  useFadeUp(rightRef);

  return (
    <section className="vm-hero">
      <div className="vm-inner">
        <div className="vm-hero__grid">
          <div className="vm-hero__left">
            <h1 ref={titleRef} className="vm-hero__title">
              EP 40 | Finding investors through the funding winter | Vasudha Madhavan
            </h1>
            <div ref={spotifyRef} className="vm-hero__spotify">
              <iframe
                src="https://open.spotify.com/embed/episode/6cgHVwVNAfToS1nMVBaDv9?utm_source=generator&theme=0"
                allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                loading="lazy"
                title="EP 40 Spotify Player"
              />
            </div>
          </div>
          <div ref={rightRef} className="vm-hero__right">
            <YouTubeEmbed />
          </div>
        </div>
      </div>
    </section>
  );
}

function BodySection() {
  const ref = useRef(null);
  useFadeUp(ref);
  return (
    <section ref={ref} className="vm-body">
      <div className="vm-inner">
        <p className="vm-body__para">
          On the show, we rarely have the same guest visit twice. Today, we talk to a very special person who's coming on the show for the third time: none other than Vasudha Madhavan, CEO &amp; Founder at Ostara Advisors. She is an investment banker who helps facilitate investments as well as M&amp;A transactions in the Electric Vehicle Space. In this special episode, we talk about the Funding Winter, major deals this year from January to August, the categories that are doing well, and much more.
        </p>
      </div>
    </section>
  );
}

function GuestSection() {
  const ref = useRef(null);
  useFadeUp(ref);
  return (
    <section ref={ref} className="vm-guest">
      <div className="vm-inner">
        <h2 className="vm-guest__title">Our Guest</h2>
        <div>
          <div className="vm-guest__photo-bg">
            <img src={GuestImg} alt="Vasudha Madhavan" />
          </div>
          <p className="vm-guest__name">Vasudha Madhavan</p>
        </div>
      </div>
    </section>
  );
}

export default function Ep40VasudhaMadhavan() {
  return (
    <>
      <style>{CSS}</style>
      <div className="vm-page">
        <HeroSection />
        <BodySection />
        <GuestSection />
      </div>
    </>
  );
}